import {
  isTimeDimension,
  timeDimensionLabel as tdLabel,
} from "../facets/index.js";
const Comp = {
  mean: "mean",
  previous: "previous",
  pctIncrease: "pctIncrease",
};
export const analyzable = (query) => {
  const hasMeasure = query.aggregations?.length;
  const hasTimeDimension = query.groupBys?.some(isTimeDimension);
  const hasAtMostTwoGroupBys = (query.groupBys?.length || 0) < 3;
  return hasMeasure && hasTimeDimension && hasAtMostTwoGroupBys;
};
export const timeDimensionLabel = (query) => {
  const dim = query.groupBys?.find(isTimeDimension);
  return dim ? tdLabel(dim) : null;
};
